module.exports = __webpack_public_path__ + "img/card.a9c93365.png";